import React, { useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Image, Grid } from "antd";

const { useBreakpoint } = Grid;

export default function CarouselWithThumbnails(file) {
  const screens = useBreakpoint();

  const fileList = file.fileList || [];

  const dotContainerRef = useRef();

  const scrollToActiveDot = (index) => {
    const container = dotContainerRef.current;
    if (!container) return;

    const activeDot = container.querySelector(`li.slick-active`);
    if (activeDot) {
      const containerRect = container.getBoundingClientRect();
      const dotRect = activeDot.getBoundingClientRect();

      const offset =
        dotRect.left -
        containerRect.left -
        container.clientWidth / 2 +
        dotRect.width / 2;

      container.scrollLeft += offset;
    }
  };

  const settings = {
    adaptiveHeight: true,
    dots: true,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (index) => scrollToActiveDot(index),
    dotsClass: "slick-dots custom-thumb-scroll",
    customPaging: (i) => (
      <img
        src={fileList[i].url}
        alt={`thumb-${i}`}
        style={{
          marginTop: 5,
          width: "100%",
          height: "100%",
          // objectFit: "cover",
          borderRadius: "6px",
        }}
      />
    ),
  };

  // Grab the slick-dots DOM element once it's rendered
  useEffect(() => {
    const dots = document.querySelector(".slick-dots.custom-thumb-scroll");
    if (dots) dotContainerRef.current = dots;
  }, []);

  return (
    <Slider
      {...settings}
      style={{
        minWidth: 0,
        marginTop: 15,
        width:
          screens.lg || screens.xl || screens.xxl
            ? 480 // larger than tablet
            : "100%", // mobile
      }}
    >
      {fileList.map((file) => (
        <Image
          className="carousel-image"
          key={file.uid}
          src={file.url}
          alt={file.name}
          width="100%"
          style={{
            width: "100%",
            height: screens.xs ? 280 : 380,
            // objectFit: "cover",
          }}
        />
      ))}
    </Slider>
  );
}
